<header class="sf-header">
  <h1>{{'pay.title'|transloco}}</h1>
</header>

<div class="pay container">
  <section class="pay__explanation sf-section">
    <h2 class="sf-section__title">{{'pay.banner.title'|transloco}}</h2>
    <p class="sf-section__subtitle">{{'pay.banner.content'|transloco}}</p>

    <div class="pay__explanation-steps">
      <div class="pay__explanation-step">
        <div class="pay__explanation-step-icon">
          <i class="fas fa-calendar-check"></i>
        </div>
        <h3>{{'pay.banner.steps.1.title'|transloco}}</h3>
        <p>{{'pay.banner.steps.1.content'|transloco}}</p>
      </div>
      <div class="pay__explanation-step">
        <div class="pay__explanation-step-icon">
          <i class="fas fa-calculator"></i>
        </div>
        <h3>{{'pay.banner.steps.2.title'|transloco}}</h3>
        <p>{{'pay.banner.steps.2.content'|transloco}}</p>
      </div>
      <div class="pay__explanation-step">
        <div class="pay__explanation-step-icon">
          <i class="fas fa-hand-holding-usd"></i>
        </div>
        <h3>{{'pay.banner.steps.3.title'|transloco}}</h3>
        <p>{{'pay.banner.steps.3.content'|transloco}}</p>
      </div>
    </div>
  </section>

  <section class="pay__form sf-section">
    <h2 class="sf-section__title">{{'pay.form.title'|transloco}}</h2>
    <p class="sf-section__subtitle">{{'pay.form.subtitle'|transloco}}</p>

    <form [formGroup]="form" (ngSubmit)="savePaymentInfo()">
      <div class="input-group--side-by-side">
        <div class="input-group">
          <label for="iban">{{'pay.form.iban.label'|transloco}}</label>
          <input type="text" id="iban" formControlName="iban" placeholder="{{'pay.form.iban.placeholder'|transloco}}"/>
        </div>
        <div class="input-group">
          <label for="bic">{{'pay.form.bic.label'|transloco}}</label>
          <input type="text" id="bic" formControlName="bic" placeholder="{{'pay.form.bic.placeholder'|transloco}}" />
        </div>
      </div>

      <button
        class="button"
        type="submit"
        [disabled]="form.invalid"
        >
        <i class="fa-solid fa-floppy-disk"></i>
        {{'pay.form.save'|transloco}}
      </button>
    </form>
  </section>

  @if (payments) {
    <section class="sf-section">
      <table class="payments-list">
        <thead>
          <tr>
            <th>{{'pay.table.header.month'|transloco}}</th>
            <th>{{'pay.table.header.confirmed'|transloco}}</th>
            <th>{{'pay.table.header.pending'|transloco}}</th>
            <th>{{'pay.table.header.status'|transloco}}</th>
          </tr>
        </thead>
        <tbody>
          @if (payments.length > 0) {
            @for (payment of payments; track payment.month) {
              <tr>
                <td>{{ payment.month }}</td>
                <td>{{ payment.confirmed | currency:'EUR' }}</td>
                <td>{{ payment.pending | currency:'EUR' }}</td>
                <td>
                  @if (monthStatus(payment) === 'ongoing') {
                    <div class="tag tag--blue">
                      {{ 'pay.table.status.ongoing' | transloco }}
                    </div>
                  }
                  @if (monthStatus(payment) === 'done') {
                    <div class="tag tag--green">
                      {{ 'pay.table.status.done' | transloco }}
                    </div>
                  }
                </td>
              </tr>
            }
          }
          @if (payments.length === 0) {
            <tr>
              <td colspan="3">
                <div class="empty-state">
                  <h3 class="empty-state__title">{{'pay.table.empty-state.title'|transloco}}</h3>
                  <p class="empty-state__description">{{'pay.table.empty-state.description'|transloco}}</p>
                </div>
              </td>
            </tr>
          }
        </tbody>
        @if (payments.length > 0) {
          <tfoot>
            <tr>
              <td>{{ 'pay.table.footer.total' | transloco }}</td>
              <td>{{ totalConfirmed | currency:'EUR' }}</td>
              <td>{{ totalPending | currency:'EUR' }}</td>
              <td></td>
            </tr>
          </tfoot>
        }
      </table>
    </section>
  }
</div>
